import { render, staticRenderFns } from "./SendTableMessageModal.vue?vue&type=template&id=58e1031b"
import script from "./SendTableMessageModal.vue?vue&type=script&lang=js"
export * from "./SendTableMessageModal.vue?vue&type=script&lang=js"
import style0 from "./SendTableMessageModal.vue?vue&type=style&index=0&id=58e1031b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports